import { Menu } from '@/models/menu';
import i18n from '@/i18n';

export namespace Constants {
  export const SelfCompetencyIDs: number[] = [3, 7, 8, 9, 10, 11, 12, 13, 18];
  export const GiftCompetencyIDs: number[] = [14, 15, 16, 17, 19, 20, 21];
  export const CognitiveCompetencyIDs: number[] = [1, 2, 4, 5, 6];
  export const CommunityCompetencyIDs: number[] = [22, 23, 24, 25];
  export const CompetencyIDsBySortedType: number[] = [...CognitiveCompetencyIDs, ...SelfCompetencyIDs, ...GiftCompetencyIDs, ...CommunityCompetencyIDs];
  // 新スコア判定日
  export const NewScoreDicisionDate: Date = new Date('5/01/2023 00:00:00');

  // Service Name (aigrow or jgrow)
  export const ServiceNameJgrow: string = 'jgrow';
  export const ServiceNameAigrow: string = 'aigrow';
}

export namespace Header {
  export const SchoolYear = 'SCHOOL-YEAR';
  export const Token = 'AI-TOKEN';
}

export namespace SubMenu {
  export const StudentSetting = { menuID: 'studentSetting', name: i18n.t('REGISTRANT_INFO').toString(), path: '/pages/students' };
  export const TeacherSetting = { menuID: 'teacherSetting', name: i18n.t('MANAGE_TEACHER').toString(), path: '/pages/teachers' };
  export const SchoolClassSetting = { menuID: 'schoolClassSetting', name: i18n.t('MANAGE_SCHOOL_CLASS').toString(), path: '/pages/schoolClasses' };
  export const CustomCompetency = { menuID: 'customCompetency', name: i18n.t('SCHOOL_COMPETENCY').toString(), path: '/pages/customCompetency' };
  export const CustomBoxplotSetting = { menuID: 'customBoxplotSetting', name: i18n.t('BOXPLOT_ADDITIONAL_SETTING').toString(), path: '/pages/customBoxplotSetting' };
  export const SchoolSetting = { menuID: 'schoolSetting', name: i18n.t('SCHOOL_SETTING').toString(), path: '/pages/schoolSetting' };
}

export namespace HeadMenu {
  export const Home: Menu = { menuID: 'home', name: i18n.t('HOME').toString(), path: '/pages/home', icon: 'ios-home', subItems: [] };
  export const ClassManagement: Menu = {
    menuID: 'classManagement',
    name: i18n.t('SCHOOL_CLASS_MANAGEMENT').toString(),
    path: '/pages/class-management',
    icon: 'md-analytics',
    subItems: [],
  };
  export const Statistics: Menu = { menuID: 'statistics', name: i18n.t('STATISTIC_INFO').toString(), path: '/pages/statistics', icon: 'md-stats', subItems: [] };
  export const ExamList: Menu = { menuID: 'examList', name: i18n.t('MENU_EVAL_COURSE').toString(), path: '/pages/exam/list', icon: 'md-create', subItems: [] };
  export const SettingAndManagement: Menu = {
    menuID: 'settingAndManagement',
    name: i18n.t('SETTING_AND_MANAGE').toString(),
    path: '/pages/students',
    icon: 'md-settings',
    subItems: [SubMenu.StudentSetting, SubMenu.SchoolClassSetting, SubMenu.TeacherSetting, SubMenu.CustomCompetency, SubMenu.CustomBoxplotSetting, SubMenu.SchoolSetting],
  };
  export const SettingAndManagementUchida: Menu = {
    menuID: 'settingAndManagement',
    name: '設定・管理',
    path: '/pages/students',
    icon: 'md-settings',
    subItems: [SubMenu.StudentSetting, SubMenu.SchoolClassSetting, SubMenu.TeacherSetting, SubMenu.SchoolSetting],
  };
  export const Promotion: Menu = {
    menuID: 'academicPromotion',
    name: i18n.t('PROMOTION_SETTING').toString(),
    path: '/pages/academicPromotion',
    icon: 'md-settings',
    subItems: [],
  };
  export const InitSetting: Menu = {
    menuID: 'academicPromotion',
    name: i18n.t('INIT_SETTING').toString(),
    path: '/pages/academicPromotion',
    icon: 'md-settings',
    subItems: [],
  };
  export const Help: Menu = {
    menuID: 'help',
    name: i18n.t('LINK_TO_GUIDE').toString(),
    path: 'https://event.aigrow.jp/guide',
    icon: 'md-help-circle',
    subItems: [],
  };
}
